<template>
  <div>
    <router-link :to="this.to" class="router">
      <button @click="clicked()" :class="this.type" :style="customStyles">
        <div class="wrapper">
          <span v-if="!loading && typeof icon !== 'undefined' && icon !== ''" :class="['icon', icon]"></span>
          <span v-if="!loading">{{ title }}</span>
          <dot-loader v-if="loading"></dot-loader>
        </div>
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AdaButton",
  props: {
    title: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: true,
      default: 'button'
    },
    icon: {
      type: String,
      required: false
    },
    customStyles: {
      type: [String, Object],
      required: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    clicked: function () {
      if (!this.loading) {
        this.$emit('click');
      }
    },
    getImgUrl: function (pic) {
      return require('../assets/' + pic)
    }
  }
}

</script>

<style lang="scss" scoped>
@use "@/assets/styles/variables.scss" as *;

a {
  text-decoration: none;
}

button {
  font-size: 14px;
  padding: 0.3em;
  min-width: 10em;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

button:focus {
  outline: 0;
}

.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  margin: auto;
}

.router span {
  color: #fff;
  display: flex;
  height: 100%;
  align-items: center;
  line-height: 1;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.icon {
  margin-right: .5em;
}

.createButton {
  background-color: $pink;
  border-color: $pink;
  border-radius: 5px;
  border-style: solid;
  text-transform: uppercase;
  padding: .5em .7em .5em .7em;
}

.large {
  padding: 0.9em 3em;
  font-size: 0.85em;
}

.grey {
  background-color: $darkGrey;
  border-color: $darkGrey;
}

.large .icon {
  font-size: 1.3em;
  font-weight: lighter;
}

.fullWidthButton {
  color: $pink;
  width: 100%;
  background-color: #fff;
  border: none;
  padding: 1em;
}

.fullWidthButton .icon {
  font-size: 1.3rem !important;
}

.fullWidthButton span {
  color: inherit;
  font-size: 17px;
  font-weight: bold;
}

.fullWidthButton:hover {
  color: #fff;
}

.fullWidthButton:hover {
  background-color: $pink;
}

.dialogConfirm, .dialogCancel {
  font-weight: 500;
  border-radius: 6px;
  border-style: solid;
  text-transform: uppercase;
  padding: .7em;
}

.dialogConfirm {
  background: $pink;

}

.dialogCancel {
  background: $darkGrey;
  padding-top: .7em;
  padding-bottom: .5em;
}

.dialogConfirm .icon {
  font-size: 0.9rem;
}

.dialogCancel .icon {
  font-size: 1.2rem;
}

.blue {
  background: $blue;
  border-color: $blue;
}

.outlined {
  background: transparent;
  border: 1px solid $darkGrey;
  border-radius: 5px;
  padding: 0.5em;
  font-weight: bold;
}

.outlined span {
  color: $darkGrey
}

</style>